export default {
  form: {
    agreement: {
      label:
        'Jeg anerkender, at min elektroniske godkendelse svarer til at underskrive dette dokument, og jeg forstår, at min elektroniske underskrift er bindende.',
    },
    signed_by: {
      label: 'Navn',
      placeholder: 'Navn',
    },
    signer_first_name: {
      label: 'Fornavn',
      placeholder: 'Fornavn',
    },
    signer_last_name: {
      label: 'Efternavn',
      placeholder: 'Efternavn',
    },
    recipient_email: {
      label: 'Modtagerens e-mailadresse',
      placeholder: 'Indtast e-mailadresse',
    },
    send_to_email: {
      label: 'Send kontrakten til ejeren via e-mail ({{email}})',
    },
    additional_locations: {
      label: 'Yderligere lokationer',
      placeholder: 'Søg efter en lokation at tilføje',
    },
    special_agreements: {
      label: 'Særlige aftaler',
      placeholder: 'Indtast eventuelle særlige aftaler',
    },
  },
  labels: {
    name: 'Navn',
    date: 'Dato',
  },
  buttons: {
    sign_in_person: 'Underskriv her sammen med ejeren',
    back: 'Tilbage',
    edit_contract: 'Rediger kontrakt',
    skip: 'Spring over',
    sign: 'Underskriv',
    init_sign: 'Opret kontrakt og send',
    redo: 'Gentag',
    continue: 'Fortsæt',
    preview: 'Forhåndsvisning',
    submit: 'Indsend',
  },
  toasts: {
    failed_to_preview_contract: 'Kontrakten kunne ikke forhåndsvises',
    contract_signing_pending: 'Vent venligst, vi opretter din kontrakt...',
    failed_to_sign_contract: 'Kontrakten kunne ikke oprettes ⁉️',
    contract_got_signed: 'Kontrakten er oprettet 👌',
  },
  in_person_signing: {
    description:
      'Ejeren har modtaget dette link på e-mail og kan underskrive digitalt. Hvis ejeren er sammen med dig nu, kan du åbne underskriftssiden her.',
  },
  signature_link: {
    label: 'Signaturlink (samme link sendes til modtageren via e-mail)',
    copy: 'Kopiér',
    copied: 'Signaturlink kopieret til udklipsholderen',
  },
  header: 'Opret kontrakt',
  description: 'Gennemgå kontraktoplysningerne, og indtast den e-mailadresse, som kontrakten skal sendes til.',
};
